import api from "api";
import { useQuery } from "@tanstack/react-query";


export const useQueryPartners = () => useQuery({
	queryKey: ["partners-featured"],
	queryFn: api.partner.featured,
	staleTime: Infinity
});